
// Getter Object for ArtistsCatalog. Use it by calling mapGetters from the Vuex Host Components.



export const statementGetters = {
  statementList: (state) => state.statementList,
  statementPaymentData:(state)=>state.statementPaymentData,
  statementDetails:(state)=>state.statementDetails,
 
}


